export default __webpack_public_path__ + "static/media/nikeair.84c32093.jpg";